import React,{useState} from 'react';
import {Button,Input} from 'reactstrap';
export default function Prompt({text}){
 const [message,setMessage]=useState('');
 return <div className="mb-3"><Button color="primary" className="mb-2" onClick={async()=>{try{await navigator.clipboard.writeText(text);setMessage('Copied');}catch{setMessage('Please select and copy the text manually.');}}}>Copy prompt</Button><span className="ms-2" role="status">{message}</span><Input type="textarea" aria-label="Standardized prompt" rows={10} readOnly value={text||''}/></div>;
}
